// extracted by mini-css-extract-plugin
export default {"input":"Search_input__TfpmT","btn":"Search_btn__GE8sh"};